'use strict';

require('./target/es5');



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/index.js
// module id = 248
// module chunks = 35783957827783 172322841747965